import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { FormatProductItemProductFragmentDoc } from './FormatProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const ProductModalProductPreviewProductFragmentDoc = gql`
  fragment ProductModalProductPreviewProduct on ProductInterface {
    id
    image
    brand
    itemDescription
    longDescription
    ...FormatProductItemProduct
  }
  ${FormatProductItemProductFragmentDoc}
` as unknown as DocumentNode<Types.ProductModalProductPreviewProductFragment, unknown>
